export const sampleCategories = [{
	"id": "yj6tFsYzEsSLOTO38iij",
	"created_at": 1559321518,
	"creator_uid": "WATE",
	"last_updated": 1562135448,
	"name": "Test",
	"schedule": [{
		"id": "7lZqxvpSgpaL7Yg5ER65",
		"activated": true,
		"created_at": 1561570943,
		"creator_uid": "WATE",
		"details": "<p>Details</p>",
		"last_updated": 1562071086,
		"name": "Tuesday"
	}, {
		"id": "DbTxSDGxXzkZMAiMF6e3",
		"activated": false,
		"created_at": 1561570943,
		"creator_uid": "WATE",
		"details": "<p>8am - Test</p><p>9am - Test</p><p>10am - Test</p><p>11am - Live Test</p><p>11am - Real Test</p>",
		"last_updated": 1562135448,
		"name": "Wednesday"
	}, {
		"id": "K6WyphD3XlDxQycukN8v",
		"activated": false,
		"created_at": 1561061385,
		"creator_uid": "WATE",
		"details": "",
		"last_updated": 1562071059,
		"name": "Thursday"
	}, {
		"id": "qUoXoggaW0OC6VVCTWR5",
		"activated": false,
		"created_at": 1561135746,
		"creator_uid": "WATE",
		"details": "",
		"last_updated": 1561135746,
		"name": "Monday"
	}, {
		"id": "szRAc0YYkOHAfBJ4TssC",
		"activated": false,
		"created_at": 1561061205,
		"creator_uid": "WATE",
		"details": "<p>Test</p>",
		"last_updated": 1561449971,
		"name": "Test"
	}],
	"activated": {
		"id": "2019-07-02",
		"date": "2019-07-02",
		"last_updated": 1562071086,
		"schedule": ["7lZqxvpSgpaL7Yg5ER65"]
	}
}, {
	"id": "KzWoh2uPO8rc1HIawcs9",
	"created_at": 1559323983,
	"creator_uid": "WATE",
	"last_updated": 1562135448,
	"name": "Dining Hall",
	"schedule": [{
		"id": "Wb3APtC7hMCUFgjXC69m",
		"activated": false,
		"created_at": 1561139105,
		"creator_uid": "WATE",
		"details": "<h2>Dinner</h2><h2>Roast ChickenDinner</h2><h2>Roast ChickenDinner</h2><h2>Roast ChickenDinner</h2><h2>Roast Chicken</h2><h2>Dinner</h2><p>Roast Chicken</p><h2>Dinner</h2><h2>Roast ChickenDinner</h2><p>Roast Chicken</p><h2>Dinner</h2><p>Roast Chicken</p><h2>Dinner</h2><p>Roast Chicken</p><h2>Dinner</h2><p>Roast Chicken</p><p><br></p>",
		"last_updated": 1561954878,
		"name": "Friday"
	}, {
		"id": "ikk3ITCh2reS2NpHg1od",
		"activated": true,
		"created_at": 1561580539,
		"creator_uid": "WATE",
		"details": "<p>Test Tuesday Dining Hall</p>",
		"last_updated": 1562071086,
		"name": "Tuesday"
	}, {
		"id": "jRmnrQETHSR9Yyq05Lja",
		"activated": false,
		"created_at": 1561580540,
		"creator_uid": "WATE",
		"details": "<p>Test</p>",
		"last_updated": 1561580540,
		"name": "Wendesday"
	}, {
		"id": "ykyEpFvI8SyVTjA986aX",
		"activated": false,
		"created_at": 1561138801,
		"creator_uid": "WATE",
		"details": "",
		"last_updated": 1561138801,
		"name": "Monday"
	}],
	"activated": {
		"id": "2019-07-02",
		"date": "2019-07-02",
		"last_updated": 1562071086,
		"schedule": ["ikk3ITCh2reS2NpHg1od"]
	}
}, {
	"id": "FDZeLNrA2Nhn9z1kb8Cx",
	"created_at": 1559324218,
	"creator_uid": "WATE",
	"last_updated": 1562135448,
	"name": "Dean",
	"schedule": [{
		"id": "YKQJ8QxPAvGAoI9OnI0J",
		"activated": false,
		"created_at": 1561580488,
		"creator_uid": "WATE",
		"details": "<p>Ari Baum</p>",
		"last_updated": 1561580515,
		"name": "Wendesday"
	}, {
		"id": "wFxhZsIjTEwTJ8KjXyCD",
		"activated": false,
		"created_at": 1561145538,
		"creator_uid": "WATE",
		"details": "",
		"last_updated": 1561580634,
		"name": "Friday"
	}],
	"activated": {"id": "2019-07-02", "date": "2019-07-02", "last_updated": 1562071086, "schedule": []}
}, {
	"id": "RCQSM6GWXNSaVtblyWz8",
	"created_at": 1559325954,
	"creator_uid": "WATE",
	"last_updated": 1562135448,
	"name": "Campus Hours",
	"schedule": [{
		"id": "2vigS39WA8Qo9vyZpxvJ",
		"activated": false,
		"created_at": 1561580293,
		"creator_uid": "WATE",
		"details": "<p>Test schedule</p>",
		"last_updated": 1561580610,
		"name": "Thursday"
	}, {
		"id": "DZ0y3EtqzapZd0BIQWzx",
		"activated": false,
		"created_at": 1561580292,
		"creator_uid": "WATE",
		"details": "<p>Test schedule</p>",
		"last_updated": 1561580318,
		"name": "Wednesday"
	}],
	"activated": {"id": "2019-07-02", "date": "2019-07-02", "last_updated": 1562071086, "schedule": []}
}, {
	"id": "qw1A9766VTCV6LtLWarS",
	"created_at": 1560888749,
	"creator_uid": "WATE",
	"last_updated": 1562135448,
	"name": "Staged Test",
	"schedule": [],
	"activated": {"id": "2019-07-02", "date": "2019-07-02", "last_updated": 1562071086, "schedule": []}
}]

export const sampleCategoriesEdgeCases = [
	{
		id: '123456', name: 'Schedule', activated: 'monday', sub_categories: [
			{id: 'monday', name: "Monday", activated: true, description: "details go here. TODO: Add rich text"},
			{id: 'tuesday', name: "Tuesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'wednesday', name: "Wednesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'thursday', name: "Thursday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'friday', name: "Friday", activated: false, description: "details go here. TODO: Add rich text"},

		]
	},
	{
		id: '123457', name: 'Dining Hall', activated: 'monday', sub_categories: [
			{id: 'monday', name: "Monday", activated: true, description: "details go here. TODO: Add rich text"},
			{id: 'tuesday', name: "Tuesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'wednesday', name: "Wednesday", activated: false, description: "details go here. TODO: Add rich text"},

		]
	},
	{
		id: '123458', name: 'Duty', activated: 'monday', sub_categories: [
			{id: 'monday', name: "Monday", activated: true, description: "details go here. TODO: Add rich text"},
			{id: 'tuesday', name: "Tuesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'wednesday', name: "Wednesday", activated: false, description: "details go here. TODO: Add rich text"},

		]
	},
	{
		id: '123459', name: 'Campus Hours', activated: 'monday', sub_categories: [
			{id: 'monday', name: "Monday", activated: true, description: "details go here. TODO: Add rich text"},
			{id: 'tuesday', name: "Tuesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'wednesday', name: "Wednesday", activated: false, description: "details go here. TODO: Add rich text"},

		]
	},
	{
		id: '123450', name: 'Category With Long Title', activated: 'monday', sub_categories: [
			{id: 'monday', name: "Monday", activated: true, description: "details go here. TODO: Add rich text"},
			{id: 'tuesday', name: "Tuesday", activated: false, description: "details go here. TODO: Add rich text"},
			{id: 'wednesday', name: "Wednesday", activated: false, description: "details go here. TODO: Add rich text"},

		]
	},
]


export const sampleToth = {
	id: '2019-06-21',
	date: '2019-06-21',
	schedule: [
		{
			id: '1',
			category: 'Dining Hall', details: [
				{
					id: '1',
					name: 'Friday',
					details: '<h2>Lunch</h2><p>Pizza</p>'
				}
			]
		},
		{
			id: '2',
			category: 'Dean', details: [
				{
					id: '2',
					name: 'Friday',
					details: '<h2>Morning</h2><p>Ari Baum</p>'
				}
			]
		}
	]
}

export const icalData = [{
	"startDate": "20190319",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190319",
	"summary": "School resumes--Regular Tuesday Schedule",
	"description": ""
}, {
	"startDate": "20190319T190000",
	"endDate": "20190319T200000",
	"summary": "4th Form Eudemonia (Required)",
	"description": ""
}, {
	"startDate": "20190320",
	"summary": "Dean on Duty - Mr. Giannikas",
	"description": ""
}, {
	"startDate": "20190320T130000",
	"endDate": "20190320T140000",
	"summary": "Executive Committee Meeting",
	"description": "John Dollhopf\\n\\n",
	"location": "RAP"
}, {"startDate": "20190321", "summary": "Dean on Duty", "description": ""}, {
	"startDate": "20190321T142100",
	"endDate": "20190321T151000",
	"summary": "4th Form College Counseling Meeting (Required) - McNally Room\\; 5th Form College Counseling Meeting (Required) - CFTA",
	"description": "Sue Rooney\\n\\n\\nCollege Counseling Meeting\\n",
	"location": "4F - McNally Room 5F - CFTA"
}, {
	"startDate": "20190321T142100",
	"endDate": "20190321T153000",
	"summary": "Calendar Committee--Review of Winter 2019-2020 Calendar",
	"description": "Full Calendar Committee",
	"location": "RAP"
}, {
	"startDate": "20190321T184500",
	"endDate": "20190321T191500",
	"summary": "Math Contest (Pennsylvania Math League)",
	"description": "Clarence Oliver\\n\\n",
	"location": "Academic Center\\, 2nd floor"
}, {
	"startDate": "20190322T050000",
	"endDate": "20190322T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190322T100700",
	"endDate": "20190322T103300",
	"summary": "Chapel (Faculty Group B) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190322T183000",
	"endDate": "20190322T193000",
	"summary": "HASOGI Club Meeting",
	"description": "Lauren Hoyt lhoyt@thehill.org\\n\\n\\nHASOGI Student Life Office Student Activities\\n",
	"location": "Memorial Room"
}, {
	"startDate": "20190322T194000",
	"endDate": "20190322T203000",
	"summary": "Hill Spa Club Meeting",
	"description": "David Hoffman\\n\\n\\nLauren Hoyt (Faculty Adviser)\\n",
	"location": "Ryan Library - McNally Room"
}, {
	"startDate": "20190322T194500",
	"endDate": "20190322T213000",
	"summary": "International Film Club Meeting",
	"description": "",
	"location": "AC 201"
}, {
	"startDate": "20190323T050000",
	"endDate": "20190323T150000",
	"summary": "Weekend Duty Crew A (Dean on Duty - Mr. Allain)",
	"description": ""
}, {
	"startDate": "20190323T093000",
	"endDate": "20190323T110000",
	"summary": "View from Above The Hill - Mr. Parixit Davé\\, Columbia University",
	"description": "\\nSamir Khan\\n\\n\\n",
	"location": "CFTA"
}, {
	"startDate": "20190323T100000",
	"endDate": "20190323T105000",
	"summary": "Hill Writer's Club Meeting",
	"description": "David Hoffman\\n\\n\\nMark Pearson\\n",
	"location": "Ryan Library - Writing Center"
}, {
	"startDate": "20190323T110000",
	"endDate": "20190323T120000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n\\n",
	"location": "Map Room - Academic Building"
}, {
	"startDate": "20190323T130000",
	"endDate": "20190323T160000",
	"summary": "KOP Towne Center",
	"description": ""
}, {
	"startDate": "20190323T183000",
	"endDate": "20190323T223000",
	"summary": "AMC Movie Theatre",
	"description": ""
}, {
	"startDate": "20190323T183000",
	"endDate": "20190323T230000",
	"summary": "Holi",
	"description": "",
	"location": "Student Center"
}, {
	"startDate": "20190323T183000",
	"endDate": "20190323T213000",
	"summary": "Phoenixville Dinner Trip",
	"description": ""
}, {
	"startDate": "20190323T193000",
	"summary": "\"Much Ado About Nothing\" at Steel River",
	"description": "",
	"location": "Steel River Playhouse"
}, {
	"startDate": "20190323T193000",
	"endDate": "20190323T223000",
	"summary": "Open Gym",
	"description": ""
}, {
	"startDate": "20190323T193000",
	"endDate": "20190323T213000",
	"summary": "Skyzone",
	"description": ""
}, {
	"startDate": "20190323T200000",
	"endDate": "20190323T220000",
	"summary": "On-Campus Movie",
	"description": "",
	"location": "AV Viewing Room"
}, {
	"startDate": "20190324T083000",
	"endDate": "20190324T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190324T101000",
	"endDate": "20190324T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190324T110000",
	"endDate": "20190324T130000",
	"summary": "Brunch at Sunflower Cafe",
	"description": ""
}, {
	"startDate": "20190324T120000",
	"endDate": "20190324T160000",
	"summary": "Blu Uber",
	"description": ""
}, {
	"startDate": "20190324T120000",
	"endDate": "20190324T160000",
	"summary": "Philadelphia Museum of Art",
	"description": "",
	"location": "Philadelphia"
}, {
	"startDate": "20190324T130000",
	"endDate": "20190324T160000",
	"summary": "King of Prussia",
	"description": ""
}, {
	"startDate": "20190324T130000",
	"endDate": "20190324T160000",
	"summary": "Shopping at Trader Joe's",
	"description": ""
}, {
	"startDate": "20190324T130000",
	"endDate": "20190324T160000",
	"summary": "Super Smash Bros. Tournament",
	"description": "",
	"location": "Student Center"
}, {
	"startDate": "20190324T130000",
	"endDate": "20190324T160000",
	"summary": "Upland Square Shuttle",
	"description": ""
}, {
	"startDate": "20190324T173000",
	"endDate": "20190324T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190324T200000",
	"endDate": "20190324T230000",
	"summary": "Holi Dance",
	"description": "",
	"location": "Student Center"
}, {
	"startDate": "20190325T050000",
	"endDate": "20190325T150000",
	"summary": "AP Economics Field Trip",
	"description": ""
}, {
	"startDate": "20190325T050000",
	"endDate": "20190325T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190325T100700",
	"endDate": "20190325T103300",
	"summary": "Chapel (Faculty Group C) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190326T050000",
	"endDate": "20190326T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190326T184500",
	"endDate": "20190326T200000",
	"summary": "Course Sign-up Fair for third\\, fourth\\, and fifth formers--meet first in Chapel",
	"description": "Course Sign-up Fair\\n",
	"location": "Chapel and then Library First Floor"
}, {
	"startDate": "20190327",
	"summary": "Dean on Duty - Mr. Giannikas",
	"description": ""
}, {
	"startDate": "20190327T113000",
	"endDate": "20190327T130000",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch"
}, {
	"startDate": "20190327T122500",
	"endDate": "20190327T134600",
	"summary": "CFG Meeting",
	"description": ""
}, {
	"startDate": "20190327T130100",
	"endDate": "20190327T134600",
	"summary": "Presidential Caucus (Optional for all - only those who attend may vote)",
	"description": "All 5th formers running for 6th Form President will debate)",
	"location": "CFTA"
}, {
	"startDate": "20190327T204000",
	"endDate": "20190327T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190328",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190328T050000",
	"endDate": "20190328T150000",
	"summary": "Deadline to add a Spring Term course",
	"description": ""
}, {
	"startDate": "20190328T142100",
	"endDate": "20190328T151000",
	"summary": "Individual Adviser Meetings",
	"description": ""
}, {
	"startDate": "20190328T190000",
	"endDate": "20190328T210000",
	"summary": "Women of The Hill Book Group",
	"description": ""
}, {
	"startDate": "20190329T050000",
	"endDate": "20190329T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190329T090000",
	"endDate": "20190329T143000",
	"summary": "Admission Revisit Day",
	"description": ""
}, {
	"startDate": "20190329T100700",
	"endDate": "20190329T103300",
	"summary": "Chapel (Faculty Group D) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190329T194500",
	"endDate": "20190329T213000",
	"summary": "International Film Club",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - A/V Room"
}, {
	"startDate": "20190330T050000",
	"endDate": "20190330T150000",
	"summary": "Weekend Duty Crew C (Dean on Duty - Mr. Giannikas)",
	"description": ""
}, {
	"startDate": "20190330T090000",
	"endDate": "20190330T110000",
	"summary": "Student Leadership Workshop",
	"description": "Jason Coady jcoady@thehill.org x-7726\\n\\n",
	"location": "Ryan Library McNally Room"
}, {
	"startDate": "20190330T093000",
	"endDate": "20190330T110000",
	"summary": "Careers in STEM Symposium",
	"description": "\\nRachel Liu and Carolyn Tsiang\\n\\n\\n",
	"location": "Memorial Room"
}, {
	"startDate": "20190330T110000",
	"endDate": "20190330T120000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n\\n",
	"location": "Map Room - Academic Building"
}, {
	"startDate": "20190331T083000",
	"endDate": "20190331T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190331T101000",
	"endDate": "20190331T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190331T173000",
	"endDate": "20190331T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190401T050000",
	"endDate": "20190401T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190401T090000",
	"endDate": "20190401T143000",
	"summary": "Admission Revisit Day",
	"description": ""
}, {
	"startDate": "20190401T100700",
	"endDate": "20190401T103300",
	"summary": "Chapel (Faculty Group A) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190401T150000",
	"endDate": "20190401T200000",
	"summary": "Hill Blood Drive",
	"description": "",
	"location": "Widener Arts & Crafts"
}, {
	"startDate": "20190402T050000",
	"endDate": "20190402T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190402T183000",
	"endDate": "20190402T190000",
	"summary": "Seated Dinner (followed by Faculty Coffee)",
	"description": "Seated Dinner (followed by Faculty Coffee)",
	"location": "Dining Hall"
}, {
	"startDate": "20190402T190000",
	"endDate": "20190402T200000",
	"summary": "Presidential Debate (Adviser Seating)",
	"description": "Jennifer Lagor\\n\\n5th formers debate for School President election",
	"location": "CFTA"
}, {
	"startDate": "20190403",
	"summary": "Dean on Duty - Mr. Giannikas",
	"description": ""
}, {
	"startDate": "20190403T130000",
	"summary": "Required Sixth Form College Counseling Meeting",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190403T130100",
	"endDate": "20190403T134600",
	"summary": "Faculty Meeting",
	"description": "Katy Hudak and Len Miller\\n\\n\\n",
	"location": "McNally Room"
}, {
	"startDate": "20190403T204000",
	"endDate": "20190403T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190404",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190404T122500",
	"endDate": "20190404T125600",
	"summary": "Adviser Seated Lunch",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190404T142100",
	"endDate": "20190404T151000",
	"summary": "All School Meeting",
	"description": ""
}, {
	"startDate": "20190405T050000",
	"endDate": "20190405T150000",
	"summary": "Deadline for Sixth Formers to drop a spring term course",
	"description": ""
}, {
	"startDate": "20190405T050000",
	"endDate": "20190405T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190405T090000",
	"endDate": "20190405T143000",
	"summary": "Admission Revisit Day",
	"description": ""
}, {
	"startDate": "20190405T100700",
	"endDate": "20190405T103300",
	"summary": "Chapel (Faculty Group B) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190405T122500",
	"endDate": "20190405T125600",
	"summary": "Regular Seated Lunch Seating",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190405T183000",
	"endDate": "20190405T193000",
	"summary": "HASOGI Club Meeting",
	"description": "Lauren Hoyt lhoyt@thehill.org\\n\\n\\nHASOGI Student Life Office Student Activities\\n",
	"location": "Memorial Room"
}, {
	"startDate": "20190405T194000",
	"endDate": "20190405T203000",
	"summary": "Hill Spa Club Meeting",
	"description": "David Hoffman\\n\\n\\nLauren Hoyt (Faculty Adviser)\\n",
	"location": "Ryan Library - McNally Room"
}, {
	"startDate": "20190405T194500",
	"endDate": "20190405T213000",
	"summary": "International Film Club Meeting",
	"description": "",
	"location": "AC 201"
}, {
	"startDate": "20190406T050000",
	"endDate": "20190406T150000",
	"summary": "Weekend Duty Crew B (Dean on Duty - Mr. Eccleston)",
	"description": ""
}, {
	"startDate": "20190406T090000",
	"endDate": "20190406T110000",
	"summary": "Student Leadership Workshop",
	"description": "Jason Coady jcoady@thehill.org x-7726\\n\\n",
	"location": "Ryan Library McNally Room"
}, {
	"startDate": "20190406T110000",
	"endDate": "20190406T120000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n\\n",
	"location": "Map Room - Academic Building"
}, {
	"startDate": "20190406T180000",
	"summary": "Vollmer Leadership Dinner (for Hill Football Association and varsity football players)",
	"description": "",
	"location": "Memorial Room"
}, {
	"startDate": "20190407T083000",
	"endDate": "20190407T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190407T101000",
	"endDate": "20190407T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190407T130000",
	"endDate": "20190407T140000",
	"summary": "Epic Easter Egg Hunt",
	"description": "cneese@thehill.org\\n\\n\\nCourtney Neese\\n",
	"location": "Quad"
}, {
	"startDate": "20190407T130000",
	"endDate": "20190407T140000",
	"summary": "Opening Reception",
	"description": "",
	"location": "Boyer Gallery"
}, {
	"startDate": "20190407T173000",
	"endDate": "20190407T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {"startDate": "20190407T180000", "summary": "Sixth Form Dinner", "description": ""}, {
	"startDate": "20190408T050000",
	"endDate": "20190408T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190408T100700",
	"endDate": "20190408T103300",
	"summary": "Chapel (Faculty Group C) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190408T120000",
	"endDate": "20190408T120100",
	"summary": "Course Requests for 2019-2020 Due",
	"description": ""
}, {
	"startDate": "20190408T190000",
	"endDate": "20190408T210000",
	"summary": "Women of The Hill Book Group",
	"description": "Heather Gelting\\n\\n\\n"
}, {
	"startDate": "20190409T050000",
	"endDate": "20190409T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190409T091500",
	"endDate": "20190409T111500",
	"summary": "Sixth Form \"Hamlet\" Performance",
	"description": "\\nSixth formers miss D\\, adviser\\, E periods.\\n \\nMrs. Hudak\\n\\n\\n",
	"location": "CFTA"
}, {
	"startDate": "20190409T183000",
	"endDate": "20190409T190000",
	"summary": "Seated Dinner (followed by Faculty Coffee)",
	"description": "Seated Dinner (followed by Faculty Coffee",
	"location": "Dining Hall"
}, {
	"startDate": "20190409T190000",
	"endDate": "20190409T203000",
	"summary": "College Fair (Required 4th and 5th form)",
	"description": "\\nMrs. Deitrich\\n\\n\\n",
	"location": "Sweeney Gym"
}, {
	"startDate": "20190409T190000",
	"endDate": "20190409T203000",
	"summary": "College Fair (Required for Fourth and Fifth Form)",
	"description": "Ellen Deitrich\\n\\n\\nCollege Fair (Required for Fourth and Fifth Form)\\n",
	"location": "Sweeney"
}, {
	"startDate": "20190410",
	"summary": "Dean on Duty - Mr. Giannikas",
	"description": ""
}, {
	"startDate": "20190410T130100",
	"endDate": "20190410T134600",
	"summary": "Department Meetings",
	"description": "",
	"location": "Widener Arts and Crafts 1"
}, {
	"startDate": "20190410T204000",
	"endDate": "20190410T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {"startDate": "20190411", "summary": "Dean on Duty", "description": ""}, {
	"startDate": "20190411T142100",
	"endDate": "20190411T151000",
	"summary": "All School Meeting",
	"description": "Hill Forum",
	"location": "CFTA"
}, {
	"startDate": "20190412T050000",
	"endDate": "20190412T150000",
	"summary": "Deadline to drop a Spring Term Course",
	"description": ""
}, {
	"startDate": "20190412T050000",
	"endDate": "20190412T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190412T050000",
	"endDate": "20190412T150000",
	"summary": "Regular Economics Field Trip",
	"description": "Ari Baum\\n\\n"
}, {
	"startDate": "20190412T050000",
	"endDate": "20190412T150000",
	"summary": "Saturday Noon Departure",
	"description": "Deans' Office\\n\\n"
}, {
	"startDate": "20190412T100700",
	"endDate": "20190412T103300",
	"summary": "Chapel (Faculty Group D) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190412T183000",
	"endDate": "20190412T191500",
	"summary": "Town Hill Meeting",
	"description": "Ari Baum\\n\\n",
	"location": "RAP"
}, {
	"startDate": "20190412T190000",
	"endDate": "20190412T210000",
	"summary": "6th Annual Leadership and Career Summit (Required for 5th and 6th Forms)",
	"description": ""
}, {
	"startDate": "20190412T190000",
	"endDate": "20190412T210000",
	"summary": "Fourth Form College Speaker",
	"description": "Lauren Hoyt\\n\\n",
	"location": "McNally Room"
}, {
	"startDate": "20190412T194500",
	"endDate": "20190412T210000",
	"summary": "Third Form Social",
	"description": "Third Form Social\\n"
}, {
	"startDate": "20190412T210000",
	"endDate": "20190412T220000",
	"summary": "Student and Alumni Concert",
	"description": ""
}, {
	"startDate": "20190412T220000",
	"endDate": "20190412T220500",
	"summary": "Dorm check-in",
	"description": "Boarders check-in"
}, {
	"startDate": "20190413T050000",
	"endDate": "20190413T150000",
	"summary": "ACTs at The Hill",
	"description": ""
}, {
	"startDate": "20190413T050000",
	"endDate": "20190413T150000",
	"summary": "Weekend Duty Crew C (Dean on Duty - Mr. Giannikas)",
	"description": ""
}, {
	"startDate": "20190413T083000",
	"endDate": "20190413T120000",
	"summary": "6th Annual Leadership and Career Summit (Required for 5th and 6th Forms)",
	"description": ""
}, {
	"startDate": "20190413T083000",
	"endDate": "20190413T130000",
	"summary": "Community Service (Required for 4th Form)",
	"description": ""
}, {
	"startDate": "20190413T083000",
	"endDate": "20190413T120000",
	"summary": "Required Third Form Enrichment Learning event",
	"description": "Katy Hudak and Kelsey Bessette\\n\\n\\n"
}, {
	"startDate": "20190413T110000",
	"endDate": "20190413T120000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hofman\\n\\n\\n",
	"location": "Map Room - Academic Building"
}, {
	"startDate": "20190414T083000",
	"endDate": "20190414T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190414T101000",
	"endDate": "20190414T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190414T110000",
	"endDate": "20190414T114500",
	"summary": "Palm Sunday Service (with Holy Communion)",
	"description": "Khristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190414T173000",
	"endDate": "20190414T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190415T050000",
	"endDate": "20190415T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190415T083000",
	"endDate": "20190415T143000",
	"summary": "AP French and AP Art History Field Trip",
	"description": "",
	"location": "Philadelphia"
}, {
	"startDate": "20190415T100700",
	"endDate": "20190415T103300",
	"summary": "Chapel (Faculty Group A) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190416T050000",
	"endDate": "20190416T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190416T173000",
	"endDate": "20190416T173100",
	"summary": "Dorm Picnics",
	"description": ""
}, {
	"startDate": "20190416T190000",
	"endDate": "20190416T200000",
	"summary": "4th Form Eudemonia (Required)",
	"description": ""
}, {
	"startDate": "20190417",
	"summary": "Dean on Duty - Mr. Giannikas",
	"description": ""
}, {
	"startDate": "20190417T050000",
	"endDate": "20190417T150000",
	"summary": "Thursday Schedule",
	"description": ""
}, {
	"startDate": "20190417T204000",
	"endDate": "20190417T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {"startDate": "20190418", "summary": "Dean on Duty", "description": ""}, {
	"startDate": "20190418T050000",
	"endDate": "20190418T150000",
	"summary": "Students may depart after last commitment",
	"description": ""
}, {
	"startDate": "20190418T050000",
	"endDate": "20190418T150000",
	"summary": "Wednesday Schedule",
	"description": ""
}, {
	"startDate": "20190418T113000",
	"endDate": "20190418T130000",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch"
}, {
	"startDate": "20190418T124500",
	"endDate": "20190418T124600",
	"summary": "Buses Depart",
	"description": ""
}, {
	"startDate": "20190418T160000",
	"endDate": "20190418T160100",
	"summary": "Dorms Close",
	"description": ""
}, {
	"startDate": "20190419T050000",
	"endDate": "20190419T150000",
	"summary": "Passover (begins at sundown--Judaism)",
	"description": ""
}, {
	"startDate": "20190419T050000",
	"endDate": "20190419T150000",
	"summary": "Spring Holiday Weekend",
	"description": ""
}, {
	"startDate": "20190420T050000",
	"endDate": "20190420T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190420T050000",
	"endDate": "20190420T150000",
	"summary": "Spring Holiday Weekend",
	"description": ""
}, {
	"startDate": "20190421T050000",
	"endDate": "20190421T150000",
	"summary": "Easter (Christianity)",
	"description": ""
}, {
	"startDate": "20190421T050000",
	"endDate": "20190421T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190421T050000",
	"endDate": "20190421T150000",
	"summary": "Spring Holiday Weekend",
	"description": ""
}, {
	"startDate": "20190421T083000",
	"endDate": "20190421T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190421T101000",
	"endDate": "20190421T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190422T050000",
	"endDate": "20190422T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190422T050000",
	"endDate": "20190422T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190422T050000",
	"endDate": "20190422T150000",
	"summary": "Spring Holiday Weekend",
	"description": ""
}, {
	"startDate": "20190422T150000",
	"endDate": "20190422T150500",
	"summary": "Dorms Open",
	"description": ""
}, {
	"startDate": "20190422T174500",
	"endDate": "20190422T190000",
	"summary": "Buffet Dinner",
	"description": ""
}, {
	"startDate": "20190422T191500",
	"endDate": "20190422T191600",
	"summary": "Boarders Check In (Extra Help Permitted until 8",
	"description": "Boarders Check In (Extra Help Permitted until 8"
}, {
	"startDate": "20190423T050000",
	"endDate": "20190423T150000",
	"summary": "Classes Resume",
	"description": ""
}, {
	"startDate": "20190423T050000",
	"endDate": "20190423T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190423T050000",
	"endDate": "20190423T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190423T183000",
	"endDate": "20190423T190000",
	"summary": "Seated Dinner (followed by Faculty Coffee)",
	"description": "Seated Dinner (followed by Faculty Coffee",
	"location": "Dining Hall"
}, {
	"startDate": "20190424T050000",
	"endDate": "20190424T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190424T050000",
	"endDate": "20190424T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190424T114500",
	"endDate": "20190424T125600",
	"summary": "Buffet Lunch",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190424T122500",
	"endDate": "20190424T134600",
	"summary": "CFG Meeting",
	"description": ""
}, {
	"startDate": "20190424T130100",
	"endDate": "20190424T134600",
	"summary": "Form Caucuses and Elections (3rd\\, 4th and 5th Forms)",
	"description": "3rd form - Widener A&C 4th form - McNally Room 5th form - CFTA\\n \\n 3rd form - Widener A&C 4th form - McNally Room  5th form - CFTA"
}, {
	"startDate": "20190424T190000",
	"endDate": "20190424T210000",
	"summary": "Spring Concert Dress Rehearsal (All)",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190424T204000",
	"endDate": "20190424T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190425T050000",
	"endDate": "20190425T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190425T050000",
	"endDate": "20190425T150000",
	"summary": "Midterm",
	"description": ""
}, {
	"startDate": "20190425T050000",
	"endDate": "20190425T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190425T142100",
	"endDate": "20190425T151000",
	"summary": "Concert rehearsal--Full Tech",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190426T050000",
	"endDate": "20190426T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190426T050000",
	"endDate": "20190426T150000",
	"summary": "Grandparents' Day",
	"description": ""
}, {
	"startDate": "20190426T050000",
	"endDate": "20190426T150000",
	"summary": "Passover (Judaism)",
	"description": ""
}, {
	"startDate": "20190426T100700",
	"endDate": "20190426T103300",
	"summary": "Chapel (Faculty Group B) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190426T190000",
	"endDate": "20190426T190100",
	"summary": "Dorm Check in",
	"description": ""
}, {
	"startDate": "20190426T191500",
	"endDate": "20190426T201500",
	"summary": "Spring Music Festival",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190426T194000",
	"endDate": "20190426T203000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - Tech Lab"
}, {
	"startDate": "20190426T194500",
	"endDate": "20190426T213000",
	"summary": "International Film Club",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - A/V Room"
}, {
	"startDate": "20190427T050000",
	"endDate": "20190427T150000",
	"summary": "DECA Nationals",
	"description": ""
}, {
	"startDate": "20190427T050000",
	"endDate": "20190427T150000",
	"summary": "Passover (ends at sundown--Judaism)",
	"description": ""
}, {
	"startDate": "20190427T050000",
	"endDate": "20190427T150000",
	"summary": "Weekend Duty Crew D (Dean on Duty - Mr. Miller)",
	"description": ""
}, {
	"startDate": "20190428T050000",
	"endDate": "20190428T150000",
	"summary": "DECA Nationals",
	"description": ""
}, {
	"startDate": "20190428T080000",
	"endDate": "20190428T110000",
	"summary": "Hobart's Ram Run 5k",
	"description": "",
	"location": "Far Fields/Track"
}, {
	"startDate": "20190428T083000",
	"endDate": "20190428T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190428T101000",
	"endDate": "20190428T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190428T133000",
	"endDate": "20190428T153000",
	"summary": "Engineering Open House",
	"description": "",
	"location": "Widener Arts & Crafts - Engineering Lab"
}, {
	"startDate": "20190428T173000",
	"endDate": "20190428T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190428T173000",
	"endDate": "20190428T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190428T190000",
	"endDate": "20190428T195000",
	"summary": "J-Ball",
	"description": ""
}, {
	"startDate": "20190428T200000",
	"endDate": "20190428T213000",
	"summary": "Study Hall Begins at 8",
	"description": ""
}, {
	"startDate": "20190429T050000",
	"endDate": "20190429T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190429T050000",
	"endDate": "20190429T150000",
	"summary": "DECA Nationals",
	"description": ""
}, {
	"startDate": "20190429T090000",
	"endDate": "20190429T090100",
	"summary": "Grades Due",
	"description": ""
}, {
	"startDate": "20190429T100700",
	"endDate": "20190429T103300",
	"summary": "Chapel (Faculty Group C) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190430T050000",
	"endDate": "20190430T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190430T050000",
	"endDate": "20190430T150000",
	"summary": "DECA Nationals",
	"description": ""
}, {
	"startDate": "20190430T183000",
	"endDate": "20190430T190000",
	"summary": "Seated Dinner (followed by Faculty Coffee)",
	"description": "Seated Dinner (followed by Faculty Coffee",
	"location": "Dining Hall"
}, {
	"startDate": "20190430T190000",
	"endDate": "20190430T200000",
	"summary": "4th Form Eudemonia (Required)",
	"description": ""
}, {
	"startDate": "20190430T220000",
	"summary": "Deadline for submissions to the 2019 Revell Writing Contest",
	"description": "\\nMark Pearson\\n\\n\\n"
}, {
	"startDate": "20190501T050000",
	"endDate": "20190501T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190501T130100",
	"endDate": "20190501T134600",
	"summary": "Faculty Meeting",
	"description": "Katy Hudak and Len Miller\\n\\n",
	"location": "McNally Room"
}, {
	"startDate": "20190501T130100",
	"endDate": "20190501T134600",
	"summary": "Required Sixth Form College Counseling Meeting",
	"description": "",
	"location": "McNally Room/Ryan Library"
}, {
	"startDate": "20190501T204000",
	"endDate": "20190501T211500",
	"summary": "840 Worship",
	"description": "\\nKhristi Adams\\n\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190502T050000",
	"endDate": "20190502T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190502T142100",
	"endDate": "20190502T151000",
	"summary": "AAT Meeting",
	"description": "Jeff Hollway\\n\\n",
	"location": "RAP"
}, {
	"startDate": "20190502T142100",
	"endDate": "20190502T151000",
	"summary": "Honor Council Speeches (Required)",
	"description": "5th Form - CFTA 4th Form - Widener Arts and Crafts 3rd Form - Chapel\\n\\n5th Form - CFTA / 4th Form - Widener Arts and Crafts / 3rd Form - Chapel"
}, {
	"startDate": "20190502T153000",
	"endDate": "20190502T220000",
	"summary": "Honor Council Elections (Required) (Electronic)",
	"description": "Honor Council Elections (Electronic)"
}, {
	"startDate": "20190502T190000",
	"endDate": "20190502T210000",
	"summary": "Prize Committee Meeting",
	"description": "",
	"location": "RAP"
}, {
	"startDate": "20190503T050000",
	"endDate": "20190503T150000",
	"summary": "Day of Silence",
	"description": ""
}, {
	"startDate": "20190503T050000",
	"endDate": "20190503T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190503T100700",
	"endDate": "20190503T103300",
	"summary": "Chapel (Faculty Group D) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190503T183000",
	"endDate": "20190503T193000",
	"summary": "HASOGI Club Meeting",
	"description": "Lauren Hoyt lhoyt@thehill.org\\n\\nHASOGI Student Life Office Student Activities",
	"location": "Memorial Room"
}, {
	"startDate": "20190503T191500",
	"endDate": "20190503T201500",
	"summary": "Small Instrumental Group Concert",
	"description": "Margie Neiswender\\n\\n\\nSmall Instrumental Group Concert\\n",
	"location": "Chapel"
}, {
	"startDate": "20190503T194000",
	"endDate": "20190503T203000",
	"summary": "Hill Spa Club Meeting",
	"description": "David Hoffman\\n\\n\\nLauren Hoyt (Faculty Adviser)\\n",
	"location": "Ryan Library - McNally Room"
}, {
	"startDate": "20190503T194000",
	"endDate": "20190503T203000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - Tech Lab"
}, {
	"startDate": "20190503T201500",
	"endDate": "20190503T213000",
	"summary": "Breaking the Silence event",
	"description": "Lauren Hoyt/HASOGI\\n\\n",
	"location": "Hill House"
}, {
	"startDate": "20190504T050000",
	"endDate": "20190504T150000",
	"summary": "SATs at The Hill",
	"description": ""
}, {
	"startDate": "20190504T050000",
	"endDate": "20190504T150000",
	"summary": "Weekend Duty Crew B (Dean on Duty - Mr. Eccleston)",
	"description": ""
}, {
	"startDate": "20190504T083000",
	"endDate": "20190504T100000",
	"summary": "AAT Meeting",
	"description": "",
	"location": "RAP"
}, {
	"startDate": "20190504T100000",
	"endDate": "20190504T105000",
	"summary": "Hill Writer's Club Meeting",
	"description": "David Hoffman\\n\\nMark Pearson",
	"location": "Ryan Library - Writing Center"
}, {
	"startDate": "20190505T050000",
	"endDate": "20190505T150000",
	"summary": "Ramadan (begins at sundown--Islam)",
	"description": ""
}, {
	"startDate": "20190505T083000",
	"endDate": "20190505T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190505T100000",
	"endDate": "20190505T120000",
	"summary": "New Prefect Meeting (Required)",
	"description": "New Prefect Meeting",
	"location": "Widener Arts and Crafts 1"
}, {
	"startDate": "20190505T101000",
	"endDate": "20190505T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190505T173000",
	"endDate": "20190505T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190505T173000",
	"endDate": "20190505T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190505T181500",
	"endDate": "20190505T190000",
	"summary": "Holy Communion Service",
	"description": "Khristi Adams\\n\\n",
	"location": "Chapel"
}, {
	"startDate": "20190505T230000",
	"summary": "Deadline for Sixth Former to submit speech for Gala and Graduation ceremonies",
	"description": "\\nMark Pearson\\n\\n\\n"
}, {
	"startDate": "20190506T050000",
	"endDate": "20190506T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190506T050000",
	"endDate": "20190506T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190506T050000",
	"endDate": "20190506T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190506T080000",
	"endDate": "20190506T080100",
	"summary": "U.S. Government and Politics AP",
	"description": ""
}, {
	"startDate": "20190506T100700",
	"endDate": "20190506T103300",
	"summary": "Chapel (Faculty Group A) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190506T123000",
	"endDate": "20190506T123100",
	"summary": "Chinese Language AP",
	"description": ""
}, {
	"startDate": "20190506T123000",
	"endDate": "20190506T123100",
	"summary": "Environmental Science AP",
	"description": "Environmental Science AP"
}, {
	"startDate": "20190506T180000",
	"endDate": "20190506T200000",
	"summary": "Women of The Hill Farewell Dinner",
	"description": "",
	"location": "Feroe House"
}, {
	"startDate": "20190507T050000",
	"endDate": "20190507T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190507T050000",
	"endDate": "20190507T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190507T050000",
	"endDate": "20190507T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190507T080000",
	"endDate": "20190507T080100",
	"summary": "Spanish Language AP",
	"description": ""
}, {
	"startDate": "20190507T123000",
	"endDate": "20190507T124000",
	"summary": "Japanese AP",
	"description": ""
}, {
	"startDate": "20190507T123000",
	"endDate": "20190507T123100",
	"summary": "Physics 1",
	"description": ""
}, {
	"startDate": "20190507T173000",
	"endDate": "20190507T173100",
	"summary": "Dorm Picnics",
	"description": ""
}, {
	"startDate": "20190507T200000",
	"endDate": "20190507T210000",
	"summary": "Sixth Form Graduation Dress Review (required for 6th form girls) (Upper School 1 East)",
	"description": "Review of graduation dresses"
}, {
	"startDate": "20190508T050000",
	"endDate": "20190508T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190508T050000",
	"endDate": "20190508T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190508T050000",
	"endDate": "20190508T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190508T080000",
	"endDate": "20190508T080100",
	"summary": "English Literature AP",
	"description": ""
}, {
	"startDate": "20190508T113000",
	"endDate": "20190508T124500",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch due to large morning AP exam",
	"location": "Dining Hall"
}, {
	"startDate": "20190508T123000",
	"endDate": "20190508T123100",
	"summary": "European History AP",
	"description": ""
}, {
	"startDate": "20190508T123000",
	"endDate": "20190508T123100",
	"summary": "French Language AP",
	"description": ""
}, {
	"startDate": "20190508T130100",
	"endDate": "20190508T134600",
	"summary": "Department Meetings",
	"description": ""
}, {
	"startDate": "20190508T130100",
	"endDate": "20190508T134600",
	"summary": "Required Fifth Form College Counseling Meeting",
	"description": ""
}, {
	"startDate": "20190508T130100",
	"endDate": "20190508T134600",
	"summary": "Required Fourth Form College Counseling Meeting",
	"description": "Sue Rooney\\n\\n\\n",
	"location": "CFTA"
}, {
	"startDate": "20190509T050000",
	"endDate": "20190509T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190509T050000",
	"endDate": "20190509T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190509T050000",
	"endDate": "20190509T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190509T080000",
	"endDate": "20190509T080100",
	"summary": "Chemistry AP",
	"description": "Chemistry AP"
}, {
	"startDate": "20190509T080000",
	"endDate": "20190509T080100",
	"summary": "Spanish Literature AP",
	"description": ""
}, {
	"startDate": "20190509T123000",
	"endDate": "20190509T123100",
	"summary": "Psychology AP",
	"description": ""
}, {
	"startDate": "20190509T142100",
	"endDate": "20190509T151000",
	"summary": "All-school Meeting",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190510T050000",
	"endDate": "20190510T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190510T050000",
	"endDate": "20190510T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190510T050000",
	"endDate": "20190510T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190510T080000",
	"endDate": "20190510T080100",
	"summary": "U.S. History AP",
	"description": ""
}, {
	"startDate": "20190510T100700",
	"endDate": "20190510T103300",
	"summary": "Chapel (Faculty Group B) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190510T113000",
	"endDate": "20190510T124500",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch due to large morning AP exam",
	"location": "Dining Hall"
}, {
	"startDate": "20190510T123000",
	"endDate": "20190510T153000",
	"summary": "Computer Science Principles AP",
	"description": ""
}, {
	"startDate": "20190510T123000",
	"endDate": "20190510T124000",
	"summary": "Studio Art AP",
	"description": ""
}, {
	"startDate": "20190510T180000",
	"endDate": "20190510T200000",
	"summary": "Community Track Night",
	"description": "",
	"location": "Hauser Track"
}, {
	"startDate": "20190510T193500",
	"endDate": "20190510T203500",
	"summary": "Preston Athey Distinguished Fellow Darren Staloff (required for all US History Students)",
	"description": "\\nLen Miller\\n\\n\\n",
	"location": "McNally Room"
}, {
	"startDate": "20190510T194000",
	"endDate": "20190510T203000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - Tech Lab"
}, {
	"startDate": "20190510T194500",
	"endDate": "20190510T213000",
	"summary": "International Film Club",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - A/V Room"
}, {
	"startDate": "20190511T050000",
	"endDate": "20190511T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190511T050000",
	"endDate": "20190511T150000",
	"summary": "Weekend Duty Crew A (Dean on Duty Mr. Allain)",
	"description": ""
}, {
	"startDate": "20190512T050000",
	"endDate": "20190512T150000",
	"summary": "Mother's Day",
	"description": ""
}, {
	"startDate": "20190512T050000",
	"endDate": "20190512T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190512T083000",
	"endDate": "20190512T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190512T101000",
	"endDate": "20190512T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190512T173000",
	"endDate": "20190512T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190512T173000",
	"endDate": "20190512T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190513T050000",
	"endDate": "20190513T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190513T050000",
	"endDate": "20190513T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190513T050000",
	"endDate": "20190513T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190513T080000",
	"endDate": "20190513T080100",
	"summary": "Biology AP",
	"description": ""
}, {
	"startDate": "20190513T100700",
	"endDate": "20190513T103300",
	"summary": "Chapel (Faculty Group C) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190513T123000",
	"endDate": "20190513T123100",
	"summary": "Physics C",
	"description": ""
}, {
	"startDate": "20190513T143000",
	"endDate": "20190513T143100",
	"summary": "Physics C",
	"description": ""
}, {
	"startDate": "20190514T050000",
	"endDate": "20190514T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190514T050000",
	"endDate": "20190514T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190514T050000",
	"endDate": "20190514T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190514T080000",
	"endDate": "20190514T080100",
	"summary": "Calculus AP",
	"description": ""
}, {
	"startDate": "20190514T114500",
	"endDate": "20190514T130000",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch due to large morning AP exam",
	"location": "Dining Hall"
}, {
	"startDate": "20190514T123000",
	"endDate": "20190514T123100",
	"summary": "Art History AP",
	"description": ""
}, {
	"startDate": "20190514T183000",
	"endDate": "20190514T190000",
	"summary": "Adviser Dinners (organized by Mrs. Lagor)",
	"description": "Jennifer Lagor\\n\\nAdviser Dinners (organized by Mrs. Lagor)",
	"location": "Dining Hall"
}, {
	"startDate": "20190515T050000",
	"endDate": "20190515T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190515T050000",
	"endDate": "20190515T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190515T050000",
	"endDate": "20190515T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190515T080000",
	"endDate": "20190515T080100",
	"summary": "English Language AP",
	"description": ""
}, {
	"startDate": "20190515T114500",
	"endDate": "20190515T130000",
	"summary": "Buffet Lunch",
	"description": "Buffet Lunch due to large morning AP exam",
	"location": "Dining Hall"
}, {
	"startDate": "20190515T123000",
	"endDate": "20190515T123100",
	"summary": "Macroeconomics AP",
	"description": ""
}, {
	"startDate": "20190515T130100",
	"endDate": "20190515T134600",
	"summary": "Faculty Meeting",
	"description": "Katy Hudak and Len Miller\\n\\n",
	"location": "McNally Room"
}, {
	"startDate": "20190515T191500",
	"endDate": "20190515T201500",
	"summary": "Spring Afternoon Arts Recital",
	"description": "Spring Afternoon Arts Recital\\n",
	"location": "Chapel"
}, {
	"startDate": "20190516T050000",
	"endDate": "20190516T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190516T050000",
	"endDate": "20190516T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190516T050000",
	"endDate": "20190516T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190516T080000",
	"endDate": "20190516T082000",
	"summary": "Comparative Government and Politics and World History AP",
	"description": "Comparative Government and Politics and World History AP"
}, {
	"startDate": "20190516T123000",
	"endDate": "20190516T123100",
	"summary": "Statistics AP",
	"description": ""
}, {
	"startDate": "20190516T142100",
	"endDate": "20190516T151000",
	"summary": "Prefect Meeting (Required for Old and New Prefects)",
	"description": "Required Prefect Meeting"
}, {
	"startDate": "20190517T050000",
	"endDate": "20190517T150000",
	"summary": "AP Exams",
	"description": ""
}, {
	"startDate": "20190517T050000",
	"endDate": "20190517T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190517T050000",
	"endDate": "20190517T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190517T080000",
	"endDate": "20190517T080100",
	"summary": "Microeconomics AP",
	"description": ""
}, {
	"startDate": "20190517T080000",
	"endDate": "20190517T080100",
	"summary": "Music Theory AP",
	"description": ""
}, {
	"startDate": "20190517T100700",
	"endDate": "20190517T103300",
	"summary": "Chapel (Faculty Group D) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190517T123000",
	"endDate": "20190517T123100",
	"summary": "Computer Science A AP",
	"description": ""
}, {
	"startDate": "20190517T123000",
	"endDate": "20190517T123100",
	"summary": "Latin AP",
	"description": ""
}, {
	"startDate": "20190517T183000",
	"endDate": "20190517T193000",
	"summary": "HASOGI Club Meeting",
	"description": "Lauren Hoyt lhoyt@thehill.org\\n\\nHASOGI Student Life Office Student Activities",
	"location": "Memorial Room"
}, {
	"startDate": "20190517T183000",
	"endDate": "20190517T191500",
	"summary": "Student Art Exhibit Opening Reception and Awards",
	"description": "Joanne Egrie\\n\\n\\nStudent Art Exhibit Opening\\n",
	"location": "CFTA Lobby"
}, {
	"startDate": "20190517T191500",
	"endDate": "20190517T201500",
	"summary": "Ellis Theatre Guild Presents",
	"description": "Ellis Theatre Guild Presents",
	"location": "CFTA"
}, {
	"startDate": "20190517T194000",
	"endDate": "20190517T203000",
	"summary": "Hill Spa Club Meeting",
	"description": "David Hoffman\\n\\nLauren Hoyt (Faculty Adviser)",
	"location": "Ryan Library - McNally Room"
}, {
	"startDate": "20190517T194000",
	"endDate": "20190517T203000",
	"summary": "Student Government Association (SGA) Meeting",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - Tech Lab"
}, {
	"startDate": "20190518T050000",
	"endDate": "20190518T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190518T050000",
	"endDate": "20190518T150000",
	"summary": "Weekend Duty Crew D (Dean on Duty - Mr. Miller)",
	"description": ""
}, {
	"startDate": "20190518T181500",
	"endDate": "20190518T204500",
	"summary": "Ellis Theatre Guild Presents",
	"description": "Ellis Theatre Guild Presents",
	"location": "CFTA"
}, {
	"startDate": "20190518T201500",
	"endDate": "20190518T230000",
	"summary": "Spring Fling",
	"description": ""
}, {
	"startDate": "20190519T050000",
	"endDate": "20190519T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190519T083000",
	"endDate": "20190519T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190519T101000",
	"endDate": "20190519T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190519T130000",
	"endDate": "20190519T140000",
	"summary": "Ellis Theatre Guild Presents",
	"description": "Ellis Theatre Guild Presents",
	"location": "CFTA"
}, {
	"startDate": "20190519T160000",
	"endDate": "20190519T170000",
	"summary": "Sixth Form Tea",
	"description": "An evented hosted by Mrs. Lehman and the Women of The Hill",
	"location": "Saunders Room"
}, {
	"startDate": "20190519T173000",
	"endDate": "20190519T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190519T173000",
	"endDate": "20190519T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190519T180000",
	"endDate": "20190519T190000",
	"summary": "J-Ball Quarterfinals",
	"description": ""
}, {
	"startDate": "20190519T190000",
	"endDate": "20190519T200000",
	"summary": "Academic Open House (for new families)",
	"description": "",
	"location": "Widener Arts and Crafts 1"
}, {
	"startDate": "20190519T191500",
	"endDate": "20190519T194500",
	"summary": "Sixth Form Meeting--Required",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190520T050000",
	"endDate": "20190520T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190520T050000",
	"endDate": "20190520T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190520T100700",
	"endDate": "20190520T103300",
	"summary": "Chapel (Faculty Group A) Speaker",
	"description": "Chapel (Faculty Group X)",
	"location": "Chapel"
}, {
	"startDate": "20190520T160000",
	"endDate": "20190520T173000",
	"summary": "Fall Team Workouts",
	"description": ""
}, {
	"startDate": "20190520T180000",
	"endDate": "20190520T183000",
	"summary": "Classics Awards Assembly",
	"description": "",
	"location": "Memorial Room"
}, {
	"startDate": "20190520T193000",
	"endDate": "20190520T193100",
	"summary": "J-Ball Semifinals",
	"description": "",
	"location": "Price Field"
}, {
	"startDate": "20190521T050000",
	"endDate": "20190521T150000",
	"summary": "College T-shirt Day",
	"description": ""
}, {
	"startDate": "20190521T050000",
	"endDate": "20190521T150000",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "20190521T050000",
	"endDate": "20190521T150000",
	"summary": "Thursday Schedule",
	"description": ""
}, {
	"startDate": "20190521T143000",
	"endDate": "20190521T153000",
	"summary": "Baccalaureate Rehearsal for Leaders and Choir only",
	"description": "Baccalaureate Rehearsal for Leaders and Choir only",
	"location": "Chapel"
}, {
	"startDate": "20190521T150000",
	"endDate": "20190521T163000",
	"summary": "Fall Team Workouts",
	"description": ""
}, {
	"startDate": "20190521T150000",
	"endDate": "20190521T200000",
	"summary": "Gala Tech Rehearsal for performers only",
	"description": "Gala Tech Rehearsal for performers only",
	"location": "CFTA"
}, {
	"startDate": "20190521T154500",
	"endDate": "20190521T154600",
	"summary": "Strawberry Cutting",
	"description": "",
	"location": "Bake Shop"
}, {
	"startDate": "20190521T183000",
	"endDate": "20190521T183100",
	"summary": "Final Seated Dinner - New Prefects clean-up",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190521T184500",
	"endDate": "20190521T184600",
	"summary": "Final Faculty and Sixth Form Coffee",
	"description": ""
}, {
	"startDate": "20190521T190000",
	"endDate": "20190521T200000",
	"summary": "4th Form Eudemonia (Required)",
	"description": ""
}, {
	"startDate": "20190521T191500",
	"endDate": "20190521T204500",
	"summary": "Honors Independent Study Presentations",
	"description": "John Dollhopf\\n\\n",
	"location": "Humphrey Family Writing Center"
}, {
	"startDate": "20190522T050000",
	"endDate": "20190522T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190522T050000",
	"endDate": "20190522T150000",
	"summary": "Full Academic Dress for all students",
	"description": ""
}, {
	"startDate": "20190522T050000",
	"endDate": "20190522T150000",
	"summary": "Last Day of Classes for Sixth Form",
	"description": ""
}, {
	"startDate": "20190522T050000",
	"endDate": "20190522T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190522T130100",
	"endDate": "20190522T135000",
	"summary": "All-School Meeting--required for Faculty and Students",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190522T140000",
	"endDate": "20190522T153500",
	"summary": "Major H Pictures",
	"description": "",
	"location": "CFTA Patio"
}, {
	"startDate": "20190522T150000",
	"endDate": "20190522T150100",
	"summary": "Strawberry Festival",
	"description": "",
	"location": "Soccer Pitch"
}, {
	"startDate": "20190522T170000",
	"endDate": "20190522T180000",
	"summary": "J-Ball Championship Game",
	"description": "",
	"location": "Soccer Pitch"
}, {
	"startDate": "20190522T171500",
	"endDate": "20190522T180000",
	"summary": "Cookout Dinner",
	"description": "",
	"location": "Soccer Pitch"
}, {
	"startDate": "20190522T193000",
	"endDate": "20190522T193100",
	"summary": "Gala Rehearsal",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190522T210000",
	"endDate": "20190522T230000",
	"summary": "Sixth Form Ice Cream Social and Karaoke Party (Feroe House)",
	"description": "Sixth form only event",
	"location": "Feroe House"
}, {
	"startDate": "20190523T050000",
	"endDate": "20190523T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190523T050000",
	"endDate": "20190523T150000",
	"summary": "Modified Thursday Schedule--shortened passing time",
	"description": "Modified Thursday Schedule"
}, {
	"startDate": "20190523T050000",
	"endDate": "20190523T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190523T082500",
	"endDate": "20190523T093500",
	"summary": "G period",
	"description": ""
}, {
	"startDate": "20190523T090000",
	"endDate": "20190523T090500",
	"summary": "6th Form Grades Due",
	"description": ""
}, {
	"startDate": "20190523T094000",
	"endDate": "20190523T105000",
	"summary": "A period",
	"description": ""
}, {
	"startDate": "20190523T105500",
	"endDate": "20190523T120500",
	"summary": "B period",
	"description": ""
}, {
	"startDate": "20190523T113000",
	"endDate": "20190523T130000",
	"summary": "Buffet Lunch",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190523T125000",
	"endDate": "20190523T140000",
	"summary": "C period",
	"description": ""
}, {
	"startDate": "20190523T141500",
	"endDate": "20190523T144500",
	"summary": "Graduation Rehearsal--required for New Faculty and Marshals",
	"description": "",
	"location": "Music House"
}, {
	"startDate": "20190523T170000",
	"endDate": "20190523T180000",
	"summary": "6th Form Dance",
	"description": "6th Form Dance"
}, {
	"startDate": "20190523T180000",
	"endDate": "20190523T235500",
	"summary": "Sixth Form Dance",
	"description": "2017 Sixth Form Dance"
}, {
	"startDate": "20190523T213000",
	"endDate": "20190523T220000",
	"summary": "3rd and 4th Form Activities",
	"description": ""
}, {
	"startDate": "20190524T050000",
	"endDate": "20190524T150000",
	"summary": "Commencement Weekend--Closed Weekend",
	"description": ""
}, {
	"startDate": "20190524T050000",
	"endDate": "20190524T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190524T050000",
	"endDate": "20190524T150000",
	"summary": "Modified Wednesday Schedule",
	"description": ""
}, {
	"startDate": "20190524T050000",
	"endDate": "20190524T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190524T083000",
	"endDate": "20190524T093000",
	"summary": "Buffet Breakfast (seal patio)",
	"description": "Buffet Breakfast"
}, {
	"startDate": "20190524T094500",
	"endDate": "20190524T095500",
	"summary": "Executive Committee Meeting",
	"description": "",
	"location": "RAP"
}, {
	"startDate": "20190524T100000",
	"endDate": "20190524T111500",
	"summary": "6th Form Alumni Brunch",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190524T100000",
	"endDate": "20190524T111000",
	"summary": "D period",
	"description": ""
}, {
	"startDate": "20190524T112000",
	"endDate": "20190524T123000",
	"summary": "E period",
	"description": ""
}, {
	"startDate": "20190524T113000",
	"endDate": "20190524T123000",
	"summary": "Sixth Form Baccalaureate and Commencement Rehearsal",
	"description": "Sixth Form Baccalaureate and Commencement Rehearsal",
	"location": "Chapel"
}, {
	"startDate": "20190524T120000",
	"endDate": "20190524T133000",
	"summary": "Buffet Lunch",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190524T132000",
	"endDate": "20190524T143000",
	"summary": "F period",
	"description": ""
}, {
	"startDate": "20190524T150000",
	"endDate": "20190524T160000",
	"summary": "Legacy Tea",
	"description": "",
	"location": "Writing Center"
}, {
	"startDate": "20190524T173000",
	"endDate": "20190524T183000",
	"summary": "Underform and faculty dinner",
	"description": "",
	"location": "Dell Field"
}, {
	"startDate": "20190524T174500",
	"endDate": "20190524T190000",
	"summary": "Class Day Gala Dinner",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190524T190000",
	"endDate": "20190524T210000",
	"summary": "Class Day Gala Awards",
	"description": "",
	"location": "CFTA"
}, {
	"startDate": "20190524T194500",
	"endDate": "20190524T213000",
	"summary": "International Film Club",
	"description": "David Hoffman\\n\\n",
	"location": "Ryan Library - A/V Room"
}, {
	"startDate": "20190524T220000",
	"endDate": "20190524T235500",
	"summary": "6th Form Final Social",
	"description": "6th Form Social",
	"location": "Far Fields"
}, {
	"startDate": "20190524T220000",
	"endDate": "20190524T220500",
	"summary": "Dorm check-in",
	"description": "Boarders check-in"
}, {
	"startDate": "20190525T050000",
	"endDate": "20190525T150000",
	"summary": "Closed Weekend",
	"description": ""
}, {
	"startDate": "20190525T050000",
	"endDate": "20190525T150000",
	"summary": "Commencement Weekend",
	"description": ""
}, {
	"startDate": "20190525T050000",
	"endDate": "20190525T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190525T050000",
	"endDate": "20190525T150000",
	"summary": "Weekend Duty Crew C (Dean on Duty - Mr. Giannikas)",
	"description": ""
}, {
	"startDate": "20190525T090000",
	"endDate": "20190525T100000",
	"summary": "Baccalaureate",
	"description": "",
	"location": "Chapel"
}, {
	"startDate": "20190525T104500",
	"endDate": "20190525T121500",
	"summary": "Commencement",
	"description": ""
}, {
	"startDate": "20190525T160000",
	"endDate": "20190525T161500",
	"summary": "Sixth form final departure",
	"description": ""
}, {
	"startDate": "20190525T173000",
	"endDate": "20190525T183000",
	"summary": "Buffet Dinner",
	"description": "",
	"location": "Dining Hall"
}, {
	"startDate": "20190526T050000",
	"endDate": "20190526T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190526T083000",
	"endDate": "20190526T110000",
	"summary": "Shuttle to Morning Star Fellowship",
	"description": ""
}, {
	"startDate": "20190526T100000",
	"endDate": "20190526T120000",
	"summary": "New Prefect Meeting (Required)",
	"description": "New Prefect Meeting",
	"location": "Widener Arts and Crafts 1"
}, {
	"startDate": "20190526T101000",
	"endDate": "20190526T113000",
	"summary": "Shuttle to Roman Catholic Mass",
	"description": ""
}, {
	"startDate": "20190526T173000",
	"endDate": "20190526T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190526T173000",
	"endDate": "20190526T233000",
	"summary": "Dean on Duty - Mr. and Mrs. Eccleston",
	"description": ""
}, {
	"startDate": "20190526T193000",
	"endDate": "20190526T213000",
	"summary": "Study Hall Reverts to 7",
	"description": ""
}, {
	"startDate": "20190527T050000",
	"endDate": "20190527T150000",
	"summary": "Dean on Duty - Mrs. Lagor",
	"description": ""
}, {
	"startDate": "20190527T050000",
	"endDate": "20190527T150000",
	"summary": "Final Week of Spring Term",
	"description": ""
}, {
	"startDate": "20190527T050000",
	"endDate": "20190527T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190527T050000",
	"endDate": "20190527T150000",
	"summary": "Regular Monday Schedule with Fifth Form Chapel Move Up (no assessments may be due)",
	"description": ""
}, {
	"startDate": "20190527T100700",
	"endDate": "20190527T103300",
	"summary": "Moving Up Ceremony",
	"description": "",
	"location": "Chapel"
}, {
	"startDate": "20190527T173000",
	"endDate": "20190527T183000",
	"summary": "Cookout",
	"description": "",
	"location": "Quad"
}, {
	"startDate": "5:00 am",
	"endDate": "3:00 pm",
	"summary": "Dean on Duty - Mr. Dollhopf",
	"description": ""
}, {
	"startDate": "5:00 am",
	"endDate": "3:00 pm",
	"summary": "No Family Night--students may attend extra help and library open",
	"description": ""
}, {
	"startDate": "5:00 am",
	"endDate": "3:00 pm",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "8:30 am",
	"endDate": "11:30 am",
	"summary": "Extra time Science Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "8:30 am",
	"endDate": "10:30 am",
	"summary": "Science Assessments",
	"description": "",
	"location": "Mercer Field House"
}, {
	"startDate": "9:30 am",
	"endDate": "11:00 am",
	"summary": "Calendar Committee--Review of Spring 2020 Calendar",
	"description": "",
	"location": "RAP"
}, {
	"startDate": "12:15 pm",
	"endDate": "2:30 pm",
	"summary": "F Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {"startDate": "12:30 pm", "endDate": "2:00 pm", "summary": "F Period", "description": ""}, {
	"startDate": "2:45 pm",
	"endDate": "4:15 pm",
	"summary": "G Period",
	"description": ""
}, {
	"startDate": "2:45 pm",
	"endDate": "5:00 pm",
	"summary": "G Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190529T050000",
	"endDate": "20190529T150000",
	"summary": "Dean on Duty - Mr. Miller",
	"description": ""
}, {
	"startDate": "20190529T050000",
	"endDate": "20190529T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190529T083000",
	"endDate": "20190529T100000",
	"summary": "A Period",
	"description": ""
}, {
	"startDate": "20190529T083000",
	"endDate": "20190529T104500",
	"summary": "A Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190529T121500",
	"endDate": "20190529T143000",
	"summary": "B Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190529T123000",
	"endDate": "20190529T140000",
	"summary": "B Period",
	"description": ""
}, {
	"startDate": "20190529T144500",
	"endDate": "20190529T161500",
	"summary": "C period",
	"description": ""
}, {
	"startDate": "20190529T144500",
	"endDate": "20190529T170000",
	"summary": "C period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190530T050000",
	"endDate": "20190530T150000",
	"summary": "Dean on Duty",
	"description": ""
}, {
	"startDate": "20190530T050000",
	"endDate": "20190530T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190530T083000",
	"endDate": "20190530T113000",
	"summary": "Extra Time Math Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190530T083000",
	"endDate": "20190530T103000",
	"summary": "Math Assessments",
	"description": "",
	"location": "Mercer Field House"
}, {
	"startDate": "20190530T121500",
	"endDate": "20190530T143000",
	"summary": "D Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190530T123000",
	"endDate": "20190530T140000",
	"summary": "D Period",
	"description": ""
}, {
	"startDate": "20190530T164500",
	"endDate": "20190530T171500",
	"summary": "Dorm Check-in (required for boarders on campus)",
	"description": "Dorm Check-in"
}, {
	"startDate": "20190531T050000",
	"endDate": "20190531T150000",
	"summary": "Dean on Duty - Mr. Allain",
	"description": ""
}, {
	"startDate": "20190531T050000",
	"endDate": "20190531T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190531T050000",
	"endDate": "20190531T150000",
	"summary": "Students Depart",
	"description": ""
}, {
	"startDate": "20190531T083000",
	"endDate": "20190531T104500",
	"summary": "E Period for Extra Time Assessments",
	"description": "Kayleigh Summers\\n\\n",
	"location": "TBA"
}, {
	"startDate": "20190531T090000",
	"endDate": "20190531T103000",
	"summary": "E Period",
	"description": ""
}, {
	"startDate": "20190531T113000",
	"endDate": "20190531T113100",
	"summary": "Students may depart",
	"description": ""
}, {
	"startDate": "20190531T160000",
	"endDate": "20190531T160100",
	"summary": "Dormitories Close",
	"description": ""
}, {
	"startDate": "20190531T180000",
	"endDate": "20190531T210000",
	"summary": "Opening Reception",
	"description": "Joanne Egrie\\n\\n\\n",
	"location": "Boyer Gallery"
}, {
	"startDate": "20190601T050000",
	"endDate": "20190601T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190601T050000",
	"endDate": "20190601T150000",
	"summary": "SATs at The Hill",
	"description": ""
}, {
	"startDate": "20190602T050000",
	"endDate": "20190602T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190603T050000",
	"endDate": "20190603T150000",
	"summary": "Administrative Meetings",
	"description": ""
}, {
	"startDate": "20190603T050000",
	"endDate": "20190603T150000",
	"summary": "Ramadan (Islam)",
	"description": ""
}, {
	"startDate": "20190603T090000",
	"endDate": "20190603T090100",
	"summary": "Grades Due",
	"description": ""
}, {
	"startDate": "20190603T120000",
	"endDate": "20190603T130000",
	"summary": "Staff Appreciation Luncheon",
	"description": ""
}, {
	"startDate": "20190604T050000",
	"endDate": "20190604T150000",
	"summary": "Faculty Meetings",
	"description": "Katy Hudak and Len Miller\\n\\n"
}, {
	"startDate": "20190604T050000",
	"endDate": "20190604T150000",
	"summary": "Ramadan (ends at sundown--Islam)",
	"description": ""
}, {
	"startDate": "20190604T180000",
	"endDate": "20190604T190000",
	"summary": "Faculty and Staff Party",
	"description": ""
}, {
	"startDate": "20190605T090000",
	"endDate": "20190605T140000",
	"summary": "Faculty Meetings",
	"description": "Katy Hudak and Len Miller\\n\\n"
}, {
	"startDate": "20190605T140000",
	"endDate": "20190605T150000",
	"summary": "Executive Committee Meeting",
	"description": "",
	"location": "Memorial Room"
}, {
	"startDate": "20190605T150000",
	"endDate": "20190605T160000",
	"summary": "Prize Committee Meeting",
	"description": "",
	"location": "Memorial Room"
}, {
	"startDate": "20190606T050000",
	"endDate": "20190606T150000",
	"summary": "Trustees Weekend",
	"description": ""
}, {
	"startDate": "20190607T050000",
	"endDate": "20190607T150000",
	"summary": "Alumni Weekend",
	"description": ""
}, {
	"startDate": "20190607T050000",
	"endDate": "20190607T150000",
	"summary": "Trustees Weekend",
	"description": ""
}, {
	"startDate": "20190607T090000",
	"endDate": "20190607T090500",
	"summary": "Academic Comments Due",
	"description": ""
}, {
	"startDate": "20190607T090000",
	"endDate": "20190607T090500",
	"summary": "Afternoon Activity Comments Due",
	"description": ""
}, {
	"startDate": "20190607T090000",
	"endDate": "20190607T090500",
	"summary": "Residential Comments Due",
	"description": ""
}, {
	"startDate": "20190608T050000",
	"endDate": "20190608T150000",
	"summary": "Alumni Weekend",
	"description": ""
}, {
	"startDate": "20190608T050000",
	"endDate": "20190608T150000",
	"summary": "Trustees Weekend",
	"description": ""
}, {
	"startDate": "20190611T090000",
	"endDate": "20190611T090500",
	"summary": "Adviser Comments Due (Email to parents and in MyBackpack)",
	"description": ""
}]